// Share overlapping focus/search refreshes; a failed request can be retried.
export function createCatalogRefresh(load) {
  let pending = null;
  const refresh = () => {
    if (!pending) pending = Promise.resolve().then(load).finally(() => { pending = null; });
    return pending;
  };
  refresh.wait = () => pending || Promise.resolve();
  return refresh;
}
